import React from 'react';
import { Section } from './Section';
import { ShieldIcon, TrendingUpIcon, HeartPulseIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const pillars = [{
  icon: <TrendingUpIcon className="w-8 h-8 text-navy" data-id="element-233" />,
  title: 'Acumulación en Moneda Dura (UDIs/Dólares)',
  desc: 'Tu ahorro crece por encima de la inflación, garantizado por contrato.'
}, {
  icon: <ShieldIcon className="w-8 h-8 text-navy" data-id="element-234" />,
  title: 'Devolución Total de Capital',
  desc: 'Si llegas a la meta (tu retiro o el fondo educativo), recibes el 100% de lo acordado para disfrutarlo.'
}, {
  icon: <HeartPulseIcon className="w-8 h-8 text-navy" data-id="element-235" />,
  title: 'Auto-Pago por Invalidez',
  desc: 'Si un accidente te impide trabajar, la aseguradora paga el resto de tus mensualidades por ti y te entrega tu ahorro completo al final.'
}];
export function UniqueMechanism() {
  return <Section bg="navy" data-id="element-236">
      <div className="text-center mb-8 md:mb-16 max-w-3xl mx-auto" data-id="element-237">
        <h2 className="text-2xl md:text-5xl font-bold mb-3 md:mb-6 text-gold" data-id="element-238">
          El Método Dotal 360
        </h2>
        <h3 className="text-lg md:text-2xl text-white mb-4 md:mb-8" data-id="element-239">
          (Blindaje Protege Hoy)
        </h3>
        <p className="text-base md:text-lg text-gray-light leading-relaxed" data-id="element-240">
          Es una estructura financiera privada, inembargable y exenta de
          impuestos (Art. 93/151 LISR) que combina tres pilares:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-241">
        {pillars.map((pillar, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2,
        duration: 0.6
      }} className="bg-navy-light rounded-xl md:rounded-2xl p-5 md:p-8 border border-gold/20 relative overflow-hidden group" data-id="element-242">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-full blur-3xl group-hover:bg-gold/10 transition-colors" data-id="element-243"></div>

            <div className="w-12 h-12 md:w-16 md:h-16 bg-gold rounded-xl md:rounded-2xl flex items-center justify-center mb-4 md:mb-8 shadow-lg shadow-gold/20" data-id="element-244">
              {pillar.icon}
            </div>

            <h4 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-4 md:h-14" data-id="element-245">
              {pillar.title}
            </h4>
            <p className="text-gray-light leading-relaxed text-sm md:text-base" data-id="element-246">
              {pillar.desc}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}